import React from 'react';

export const MarketMappedColumn = [
  {
    header: 'Extrenal',
    accessorKey: 'External',
    enableColumnFilter: false,
    enableSorting: false,
    columns: [
      {
        header: 'External Product Description',
        accessorKey: 'Long',
        size: 270
      },
      {
        header: 'External Short Description',
        accessorKey: 'Short',
        size: 270
      },
      // {
      //   header: 'External Tag',
      //   accessorKey: 'Tag',
      //   size: 120
      // },
      // {
      //   header: 'External Hierarchy Number',
      //   accessorKey: 'HierNum',
      //   size: 270
      // },
      // {
      //   header: 'External Hierarchy Name',
      //   accessorKey: 'HierName',
      //   size: 270
      // },
      // {
      //   header: 'External Hierarchy Level',
      //   accessorKey: 'HierLevelNum',
      //   size: 270
      // },
      // {
      //   header: 'External Hierarchy Level Name',
      //   accessorKey: 'HierLevelName',
      //   size: 270
      // },
      // {
      //   header: 'External Parent TAG',
      //   accessorKey: 'ParentTag',
      //   size: 270
      // },
      // {
      //   header: 'Unique TAG',
      //   accessorKey: 'UniqueTag',
      //   size: 270
      // }
    ]
  },
  {
    header: 'Internal',
    accessorKey: 'internal',
    enableColumnFilter: false,
    enableSorting: false,
    columns: [
      {
        header: 'Cell',
        accessorKey: 'Cell',
        size: 100
      },
      {
        header: 'Country',
        accessorKey: 'Country',
        size: 100
      },
      // {
      //   header: 'Category',
      //   accessorKey: 'Category',
      //   size: 100
      // },
      // {
      //   header: 'Channel',
      //   accessorKey: 'Channel',
      //   size: 100
      // },
      // {
      //   header: 'Total Market',
      //   accessorKey: 'TotalMarket',
      //   size: 140
      // },
      // {
      //   header: 'Channel Confidence',
      //   accessorKey: 'ChannelConfidence',
      //   size: 140
      // },
      // {
      //   header: 'Total Confidence',
      //   accessorKey: 'TotalConfidence',
      //   size: 160
      // }
    ]
  }
];
